<input type="number" [ngModel]="size" (ngModelChange)="sizeChanged($event)" nbInput min="25" max="100" step="25">
